/**
 * Ask Coffee intent classifier client.
 *
 * Calls the `ask-coffee-intent` edge function which uses Lovable AI with
 * tool-calling to decide whether the user's message is a CRUD action on a
 * deal (currently the only supported entity) and extract the parameters.
 */

const INTENT_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/ask-coffee-intent`;

export interface DealIntent {
  intent: "create_deal" | "none";
  reply: string;
  deal?: {
    company?: string;
    name?: string;
    amount?: number;
    stage?: string;
    closeDate?: string;
    owner?: string;
  };
}

export async function classifyAskCoffeeIntent(message: string): Promise<DealIntent | null> {
  try {
    const resp = await fetch(INTENT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY}`,
        apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      },
      body: JSON.stringify({ message }),
    });
    if (!resp.ok) {
      console.warn("ask-coffee-intent failed:", resp.status);
      return null;
    }
    return (await resp.json()) as DealIntent;
  } catch (e) {
    console.warn("ask-coffee-intent error:", e);
    return null;
  }
}